const find = (selector, scope = document) => scope.querySelector(selector)
const findAll = (selector, scope = document) => [].slice.call(scope.querySelectorAll(selector))

const components = {}

const register = (name, component) => {
  components[name] = component
  document.addEventListener('DOMContentLoaded', () => {
    apply(name)
  })
}

const apply = (name, scope = document) => {
  findAll(`[data-component=${name}]`, scope).forEach(el => components[name](el))
}

const applyAll = (scope) => {
  Object.keys(components).forEach(name => {
    apply(name, scope)
  })
}

const identifyNodes = (nodes, identifier) =>
  nodes.filter(node =>
    node.props['data-identifier'] === identifier
  )

const throttle = function (func, wait) {
  let waiting = false
  return function () {
    if (waiting) {
      return
    }

    waiting = true
    setTimeout(() => {
      func.apply(this, arguments)
      waiting = false
    }, wait)
  }
}

export {
  find,
  findAll,
  register,
  apply,
  applyAll,
  identifyNodes,
  throttle
}
